import React from "react";
const AuctionHeading = () => {
    return (
        <div className="_auction_heading">
            <div className="_nft_content_txt">
                <h2 className="_nft_content_title">Wicked Cranium #4449</h2>
            </div>
            <div className="_nft_content_info_wrap">
                <h4 className="_nft_content_info_title">Artist</h4>
                <div className="_nft_content_info_inner">
                    <ul className="_nft_content_info_ul">
                        <li className="_nft_content_info_li">
                            <span className="_nft_content_info_li_txt">
                                6
                                <span>
                                    owners
                                </span>
                            </span>
                            <span className="_nft_content_info_li_ic">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                    fill="none" viewBox="0 0 32 32">
                                    <path stroke="#000" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2.354"
                                        d="M10.82 23.736h12.75V10.984m0 12.752L8.27 8.434l15.302 15.302Z" />
                                </svg>
                            </span>
                        </li>
                        <li className="_nft_content_info_li">
                            <span className="_nft_content_info_li_ic">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                    fill="none" viewBox="0 0 30 30">
                                    <path stroke="#808191" stroke-linecap="round"
                                        stroke-linejoin="round" stroke-width="2.423"
                                        d="M15.29 25.092c-.411.146-1.09.146-1.502 0-3.513-1.2-11.365-6.203-11.365-14.684 0-3.744 3.017-6.773 6.737-6.773a6.683 6.683 0 0 1 5.38 2.714 6.7 6.7 0 0 1 5.379-2.714c3.72 0 6.737 3.029 6.737 6.773 0 8.481-7.852 13.485-11.365 14.684Z" />
                                </svg>
                            </span>
                            <span className="_nft_content_info_li_txt2">
                                232
                            </span>
                        </li>
                        <li className="_nft_content_info_li">
                            <span className="_nft_content_info_li_ic">
                                <img src="assets/img/i.png" alt="i" className="_nft_content_info_li_ic_img" />
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="_nft_content_profile_wrap">
                <div className="_nft_content_profile_img_wrap">
                    <img src="assets/img/profile.png" alt="" className="_nft_content_profile_img" />
                </div>
                <h3 className="_nft_content_profile_title">Emon pixels</h3>
            </div>
            <div className="_nft_content_profile_p_wrap">
                <p className="_nft_content_profile_p">
                    Minimum Bid
                    <span>$ 1.00</span>
                </p>
                <p className="_nft_content_profile_p">
                    Minimum Increment
                    <span>$ 1.00</span>
                </p>
            </div>
        </div>
    )
}
export default AuctionHeading;